import { getPageLanguage } from '@/infrastructure/Utils'
const mixin = {
  computed: {
    termsAndConditions() {
      return `<button role="button" aria-label="link-terms-conditions" class="btn btn-link--inline font-weight-bold" data-target="#modal-default" data-href="/${getPageLanguage().toLowerCase()}/system/include/modal/rewards-terms-conditions">${this.translate(
        'rwTermsAndConditions'
      )}</button>`
    },
    linkPrivacyPolicy() {
      return `<button role="button" aria-label="link-privacy-policy" class="btn btn-link--inline font-weight-bold" data-target="#modal-default" data-href="/${getPageLanguage().toLowerCase()}/system/include/modal/privacy-policy#loyalty-programs">${this.translate(
        'rwPrivacyPolicy'
      )}</button>`
    },
    linkMarketingEmailConsent() {
      return `<button role="button" aria-label="link-privacy-policy" class="btn btn-link--inline font-weight-bold" data-target="#modal-default" data-href="/${getPageLanguage().toLowerCase()}/system/include/modal/privacy-policy#subscription-to-our-newsletters">${this.translate(
        'rwPrivacyPolicy'
      )}</button>`
    },
    lblTermsAndConditions() {
      return this.translate('rwAgreeTermsAndConditions', undefined, this.termsAndConditions)
    },
    lblPrivacyPolicy() {
      return this.translate('bmmdAgreePrivacyPolicy', undefined, this.linkPrivacyPolicy)
    },
    lblMarketingEmailsConsent() {
      return this.translate(
        'rwAgreeReceiveCommunications',
        undefined,
        this.linkMarketingEmailConsent
      )
    }
  }
}

export default mixin
